import CustomDialog from 'components/CustomDialog';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import * as jsDiff from 'diff';

const SLayout = styled.div``;

const CompareModal = ({ isShow = true, originalText, changedText, onClose = () => null }) => {
    const [changes, setChanges] = useState([]);

    const cancel = () => {
        onClose();
    };

    useEffect(() => {
        const oValue = originalText === '-' ? '' : originalText ?? '';
        const nValue = changedText === '-' ? '' : changedText ?? '';

        const diff = jsDiff.diffWords(oValue, nValue);
        setChanges(diff);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SLayout>
            <CustomDialog
                title={'Compare changes'}
                disableCancelButton
                isShow={isShow}
                onCancel={cancel}
                onConfirm={cancel}
            >
                <div style={{ width: 500, padding: 10, border: '1px solid #dcdcdc', borderRadius: 5 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {changes.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: item.added
                                            ? 'lightgreen'
                                            : item.removed
                                            ? 'salmon'
                                            : '',
                                        textDecoration: item.removed ? 'line-through' : 'initial',
                                        whiteSpace: 'pre-wrap',
                                        letterSpacing: 0.5,
                                        padding: 2,
                                    }}
                                >
                                    {item.value}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </CustomDialog>
        </SLayout>
    );
};

export default CompareModal;
